//  Clamped text - collapses text and places a "MORE+" button at the end if text is more lines than props.numLines
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button } from '@material-ui/core'
import styles from './ClampedText.icss'

// NOTE: do not set the children to an element that displays with extra margin as a block (e.g. 'p') - or the clamped size will be incorrectly calculated

class ClampedText extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			clamped: true,
			clampable: null
		}

		this.setTextContainerElement = (element) => {
			if (element) {
				const rects = element.getClientRects()
				const clampable = rects && rects.length > this.props.numLines
				// get the height of numLines of text rendered with applicable line height (which will have been truncated to whole pixels)
				const maxHeight = clampable && rects[this.props.numLines].top - rects[0].top
				this.setState({ clampable, maxHeight })
			}
		}

		this.moreClickHandler = this.moreClickHandler.bind(this)
	}

	moreClickHandler() {
		this.setState({ clamped: false })
	}

	render() {
		const { numLines, ...props } = this.props
		const className = classNames(
			styles.moreText, {
				[this.state.clamped ? styles.clampedText : styles.expandedText]: this.state.clampable,
				[styles.textMeasure]: this.state.clampable === null
			}
		)

		return (
			<div {...props}>
				<span ref={this.setTextContainerElement} className={className} style={this.state.clampable && this.state.clamped && this.state.maxHeight ? { maxHeight: `${this.state.maxHeight}px` } : {}}>
					{this.props.children}
				</span>
				{this.state.clampable && this.state.clamped && (
					<Button variant="text" onClick={this.moreClickHandler} className={styles.moreButton}>
						{this.context.translate('More +')}
					</Button>
				)}
			</div>
		)
	}
}

ClampedText.propTypes = {
	children: PropTypes.node,
	numLines: PropTypes.number
}

ClampedText.defaultProps = {
	children: undefined,
	numLines: 3
}

ClampedText.contextTypes = {
	translate: PropTypes.func
}

export default ClampedText



// WEBPACK FOOTER //
// ./src/components/ClampedText.jsx